import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import styled from 'styled-components';
import { Checkbox as UnstyledCheckbox } from '@zocdoc/components/src/Checkbox';
import CollapsibleSection from '@zocdoc/components/src/CollapsibleSection';
import { FontFamily } from '@zocdoc/components/src/typography';

export const LOCALIZED_STRINGS = defineMessages({
    Title: {
        id: 'Components.RefineSearch.OtherFilters.Title',
        defaultMessage: `{count, plural,
            =0 {additional criteria}
            other {additional criteria (#)}
        }`,
    },
    SeesChildren: {
        id: 'Components.RefineSearch.OtherFilters.SeesChildren',
        defaultMessage: 'sees children',
    },
});

export const Checkbox = styled(UnstyledCheckbox)`
    font-family: ${FontFamily.SharpSansSemibold};
`;

const OtherFilters = ({
    defaultOpen,
    intl,
    numApplied,
    onChangeCallback,
    showProvidersWhoSeeChildren,
    trackFilterClickAdditionalCriteria = () => {},
}) => {
    const title = intl.formatMessage(LOCALIZED_STRINGS.Title, {
        count: numApplied,
    });

    const seesChildren = intl.formatMessage(LOCALIZED_STRINGS.SeesChildren);

    const onChecked = update => {
        const trackingLabel = update ? 'Checked Sees Children' : 'Unchecked Sees Children';
        trackFilterClickAdditionalCriteria(trackingLabel);
        onChangeCallback({ showProvidersWhoSeeChildren: update });
    };

    return (
        <CollapsibleSection
            data-test="search-refine-misc"
            defaultOpen={defaultOpen}
            headerText={title}
        >
            <Checkbox
                checked={showProvidersWhoSeeChildren}
                data-test="search-refine-misc-seeschildren"
                onChecked={onChecked}
            >
                {seesChildren}
            </Checkbox>
        </CollapsibleSection>
    );
};

OtherFilters.propTypes = {
    defaultOpen: PropTypes.bool,
    numApplied: PropTypes.number,
    onChangeCallback: PropTypes.func.isRequired,
    showProvidersWhoSeeChildren: PropTypes.bool.isRequired,
    trackFilterClickAdditionalCriteria: PropTypes.func,
};

export default injectIntl(OtherFilters);
